import { makeAutoObservable } from "mobx";
import {
  pagingAdministrativeUnitRefInfo,
  getAdministrativeUnitRefInfo,
  createAdministrativeUnitRefInfo,
  editAdministrativeUnitRefInfo,
  deleteAdministrativeUnitRefInfo,
  checkDuplicate,
} from "./AdministrativeUnitRefInfoService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { getDefaultOrg } from "app/common/CommonFunctions";

const resetObject = {
  keyword: "",
  year: null,
  toDetectPatientTarget: null,
  fromDetectPatientTarget: null,
  provinceId: "",
  regionId: "",
  pageIndex: 0,
  pageSize: 10
};

export default class AdministrativeUnitRefInfoStore {
  administrativeUnitRefInfoList = [];
  selectedAdministrativeUnitRefInfo = null;
  selectedAdministrativeUnitRefInfoList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  text = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  searchObject = {
    sortYear: null,//sort năm
    sortAdminUnit: null,//sort dvhc
    sortDetectPatientTarget: null,
  };
  resetObject={...resetObject}

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    const searchObject = {
      ...this.searchObject,
      ...item,
      keyword: this.text,
      pageIndex: this.page,
      pageSize: this.rowsPerPage
    };

    if (item != null) {
      searchObject.pageIndex = this.page = 1;
      searchObject.keyword = this.text = item.keyword;
    }

    this.handleSetSearchObject(searchObject)
    this.search(this.searchObject);
  };

  search = async (searchObject) => {
    this.loadingInitial = true;
    try {
      let data = await pagingAdministrativeUnitRefInfo(searchObject);
      this.administrativeUnitRefInfoList = data.data.content; 
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditAdministrativeUnitRefInfo = (id) => {
    this.getAdministrativeUnitRefInfo(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getAdministrativeUnitRefInfo(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deleteAdministrativeUnitRefInfo(this.selectedAdministrativeUnitRefInfo.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedAdministrativeUnitRefInfoList.length; i++) {
      try {
        await deleteAdministrativeUnitRefInfo(this.selectedAdministrativeUnitRefInfoList[i].id);
      } catch (error) {
        listAlert.push(this.selectedAdministrativeUnitRefInfoList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning("toast.delete_fail");
      }
    }
    this.handleClose();
    toast.success("Đã xóa thành công!");
  };

  handleSelectAdministrativeUnitRefInfo = (administrativeUnitRefInfo) => {
    this.selectedAdministrativeUnitRefInfo = administrativeUnitRefInfo;
  };

  handleSelectListAdministrativeUnitRefInfo = (administrativeUnitRefInfos) => {
    this.selectedAdministrativeUnitRefInfoList = administrativeUnitRefInfos;
  };

  getAdministrativeUnitRefInfo = async (id) => {
    if (id != null) {
      try {
        let data = await getAdministrativeUnitRefInfo(id);
        this.handleSelectAdministrativeUnitRefInfo(data.data);
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectAdministrativeUnitRefInfo(null);
    }
  };

  createAdministrativeUnitRefInfo = async (administrativeUnitRefInfo) => {
    try {
        const resCheck = await checkDuplicate(administrativeUnitRefInfo);
        if (resCheck?.data) {
          toast.warning("Đã có bản ghi chỉ tiêu năm của đơn vị này");
          return;
        }
        await createAdministrativeUnitRefInfo(administrativeUnitRefInfo);
        toast.success("Thêm mới thành công!");
        this.handleClose();
      
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editAdministrativeUnitRefInfo = async (administrativeUnitRefInfo) => {
    try {
        await editAdministrativeUnitRefInfo(administrativeUnitRefInfo);
        toast.success("Cập nhật thành công!");
        this.handleClose();

    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  deleteAdministrativeUnitRefInfo = async (id) => {
    try {
      const res = await deleteAdministrativeUnitRefInfo(id);
      if (res?.data) {
        toast.success("Đã xoá bản ghi");
      } else {
        toast.warning("Không thể xoá vì có dữ liệu ràng buộc");
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
    }
  };
  resetSearchObject = () => {
    const { region, province } = getDefaultOrg();

    this.searchObject = {
      ...resetObject,
      sortYear: null,
      sortDetectPatientTarget: null,
      sortAdminUnit: null,
      region, 
      province, 
      regionId: region?.id, 
      provinceId: province?.id
    };
    this.text = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  }

  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      sortAdminUnit: null,
      sortYear: null,
      sortDetectPatientTarget: null,
      ...item,
    };
    this.updatePageData();
  }
}
